import Vue from 'vue'

export default {
    state: {
        publicCart: [],
        loading: {
            sendDataCart: false
        }
    },
    getters: {
        publicCart: state => state.publicCart,
        totalCostCartPublic: (state, getters) => {
            return getters.publicCart
                .map(el => el.Price * el.qty)
                .reduce((acc, el) => acc + el, 0)
                .toFixed(2)
        },
        totalAmountCartPublic: (state, getters) => {
            return getters.publicCart
                .map(el => el.qty)
                .reduce((acc, el) => acc + el, 0)
        },
        loadingCartPublic: state => state.loading
    },
    mutations: {
        SET_CART_PUBLIC(state, item) {
            if (!state.publicCart.find(el => el.ItemID === item.ItemID)) {
                Vue.set(item, 'qty', 1)

                state.publicCart.push(item)
            }

            localStorage.setItem('cart', JSON.stringify(state.publicCart))
        },
        DELETE_ITEM_CART_PUBLIC: (state, id) => {
            state.publicCart.forEach(el => {
                if (el.ItemID === id) {
                    state.publicCart.splice(state.publicCart.indexOf(el), 1)

                    localStorage.setItem(
                        'cart',
                        JSON.stringify(state.publicCart)
                    )
                }
            })
        },
        QUANTITY_MORE_ITEM_CART_PUBLIC: (state, id) => {
            state.publicCart.find(el => (el.ItemID == id ? el.qty++ : null))

            localStorage.setItem('cart', JSON.stringify(state.publicCart))
        },
        QUANTITY_LESS_ITEM_CART_PUBLIC: (state, id) => {
            state.publicCart.find(el => (el.ItemID == id ? el.qty-- : null))

            localStorage.setItem('cart', JSON.stringify(state.publicCart))
        },
        DELETE_ALL_CART_PUBLIC: state => {
            state.publicCart = []

            localStorage.setItem('cart', JSON.stringify(state.publicCart))
        },
        SET_CART_PUBLIC_FROM_LOC_STOR: state => {
            state.publicCart = JSON.parse(localStorage.getItem('cart')) || []
        },
        SET_COMMENT_ITEM_CART_PUBLIC(state, { item, comment }) {
            if (state.publicCart.find(el => el.ItemID === item.ItemID)) {
                Vue.set(item, 'comment', comment)
            }

            localStorage.setItem('cart', JSON.stringify(state.publicCart))
        },
        START_SEND_DATA_CART(state) {
            state.loading.sendDataCart = true
        },
        FINISH_SEND_DATA_CART(state) {
            state.loading.sendDataCart = false
        }
    },
    actions: {
        addItemsToCardPublic({ commit }, item) {
            this.$axios.post(`/public/statistics/item-added-to-basket`, {
                id: item.ItemID
            })
            commit('SET_CART_PUBLIC', item)
        },
        deleteItemCartPublic({ commit }, id) {
            commit('DELETE_ITEM_CART_PUBLIC', id)
        },
        quantityMoreItemCartPublic({ commit }, id) {
            commit('QUANTITY_MORE_ITEM_CART_PUBLIC', id)
        },
        quantityLessItemCartPublic({ commit }, id) {
            commit('QUANTITY_LESS_ITEM_CART_PUBLIC', id)
        },
        deleteAllCartPublic({ commit }) {
            commit('DELETE_ALL_CART_PUBLIC')
        },
        setCartPublicFromLocStor({ commit }) {
            commit('SET_CART_PUBLIC_FROM_LOC_STOR')
        },
        setCommentItemCartPublic({ commit }, { item, comment }) {
            commit('SET_COMMENT_ITEM_CART_PUBLIC', { item, comment })
        },
        async sendDataCartPublic({ commit }, data) {
            commit('START_SEND_DATA_CART')

            const url = '/public/orders'

            try {
                await this.$axios.post(url, data)
            } finally {
                commit('FINISH_SEND_DATA_CART')
            }
        }
    }
}
